(function() {
'use strict';

angular
    .module('TR')
    .controller('AgentPaymentBox', AgentPaymentBox);

function AgentPaymentBox($scope, $rootScope, paymentsService, agentModeService) {
    const apb = this;
    let selectedCard;

    apb.authorizeOverride = authorizeOverride;
    apb.hideOverrideBox = hideOverrideBox;

    $scope.$watch('$parent.cm.booking.UserData.PaymentDetails.CardDetails.CardType', function(id) {
        if (!id) { return; }
        $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideUserId = undefined;
        $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideCardId = undefined;
        selectedCard = paymentsService.getCardFromId($scope.$parent.cm.paymentOptions, id);
        apb.showOverrideBox =
            selectedCard.AdminOverride &&
            !agentModeService.hasOverridePermission($rootScope.agent);
    });

    function authorizeOverride(username, password) {
        if ($scope.$parent.form.cardFeeOverrideForm.$invalid) {
            apb.overrideErrorMessage = 'Insert username and password';
            apb.formInvalid = true;
            return;
        }

        apb.formInvalid = false;
        agentModeService
            .loginOverride(username, password)
            .then(_confirmOverride, _failedOverride);
    }

    function hideOverrideBox() {
        $scope.$parent.cm.booking.cardOption = 0;
        $scope.$parent.cm.updateCardType();
        apb.overrideErrorMessage = undefined;
        apb.formInvalid = false;
        apb.showOverrideBox = false;
    }

    function _confirmOverride(overrideInfo) {
        $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideCardId = selectedCard.cardTypeId;
        $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideUserId = overrideInfo.UserName;
        apb.showOverrideBox = false;
        apb.overrideErrorMessage = undefined;
    }

    function _failedOverride(errorInfo) {
        switch (errorInfo.status) {
            case 404:
                apb.overrideErrorMessage = 'User not found';
                break;

            case 401:
                apb.overrideErrorMessage = 'Unauthorised';
                break;
        }
    }
}
})();
